import React from "react";
import MachisonHeader from "./MachisonHeader";
import MachisonSections from "./MachisonSections";

const Machison = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <MachisonHeader />
      <MachisonSections />
    </div>
  );
};

export default Machison;
